import { appDataContext } from "@/context";
import { Link } from "react-router-dom";
import { useContext } from "react";

// No styled-components here — plain HTML only.
// The LCP element (<p>) must be free of sc-* classes so styled-components
// hydration never triggers a repaint of it (~2.3s delay on mobile CPU throttle).
// All styles live in index.html .infobar-critical (the single source of truth).
const Infobar = () => {
  const dataContext = useContext(appDataContext);
  const text = dataContext?.lang;

  // Always show the first message (no random rotation).
  // Changing text after hydration would shift LCP timing to ~2.3s.
  const randomInfo = text?.infobar?.[0];

  return (
    <div className="infobar-critical">
      <p>
        {randomInfo?.text} <Link to={randomInfo?.url}>{randomInfo?.label}</Link>
      </p>
      <ul>
        {text?.top_bar?.usp?.map((item, i) => (
          <li key={`infobari_${i}`}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Infobar;
